"use client";

import { useEffect, useRef, useState } from "react";
import s from "./climate.module.css";

const CHAPTERS = [
  { id: "compare", label: "Compare places" },
  { id: "snow-elevation", label: "Moving winters" },
  { id: "sports", label: "Skiing & surfing" },
  { id: "ocean", label: "The ocean" },
  { id: "connections", label: "Connected changes" },
  { id: "your-location", label: "Your location" },
  { id: "choices", label: "What helps" },
  { id: "reading", label: "Read & reuse" },
  { id: "evidence", label: "Sources" },
];

export function ChapterNavigation() {
  const railRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState("");
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries)
          if (entry.isIntersecting) setActive(entry.target.id);
      },
      { rootMargin: "-15% 0px -65% 0px" },
    );
    for (const chapter of CHAPTERS) {
      const section = document.getElementById(chapter.id);
      if (section) observer.observe(section);
    }
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const keepVisible = () => {
      const rail = railRef.current;
      const link = rail?.querySelector<HTMLAnchorElement>('[aria-current="location"]');
      if (!rail || !link) return;
      const bounds = rail.getBoundingClientRect();
      const item = link.getBoundingClientRect();
      // Move only the horizontal chapter rail; never move the reader's page.
      if (item.left < bounds.left || item.right > bounds.right)
        rail.scrollTo({ left: rail.scrollLeft + item.left - bounds.left - 20, behavior: "instant" });
    };
    keepVisible();
    window.addEventListener("resize", keepVisible);
    return () => window.removeEventListener("resize", keepVisible);
  }, [active]);
  return (
    <nav className={s.nav} aria-label="Climate observatory sections">
      <div className={s.wrap} ref={railRef}>
        {CHAPTERS.map((chapter) => (
          <a
            key={chapter.id}
            href={`#${chapter.id}`}
            aria-current={active === chapter.id ? "location" : undefined}
          >
            {chapter.label}
          </a>
        ))}
      </div>
    </nav>
  );
}
